import { Injectable } from '@angular/core';
import * as forge from 'node-forge';
import { AES_ALGORITHM, AES_IV_SIZE, AES_KEY_SIZE, TEXT_ENCODING } from 'src/app/utils/constants';

@Injectable({
	providedIn: 'root',
})
export class EncryptionService {
	private rsaPublicKey?: forge.pki.rsa.PublicKey;

	initializePublicKey(publicKey: string): void {
		const der = forge.util.decode64(publicKey);
		const asn1 = forge.asn1.fromDer(der);
		this.rsaPublicKey = forge.pki.publicKeyFromAsn1(asn1);
	}

	encrypt(message: string): string {
		if (!this.rsaPublicKey) {
			throw new Error('Public key not initialized');
		}

		const aesKey = forge.random.getBytesSync(AES_KEY_SIZE);
		const iv = forge.random.getBytesSync(AES_IV_SIZE);

		const encryptedMessage = this.encryptMessageWithAes(message, aesKey, iv);
		const encryptedAesKey = this.rsaPublicKey.encrypt(aesKey);

		return this.pack(iv, encryptedAesKey, encryptedMessage);
	}

	private encryptMessageWithAes(message: string, aesKey: string, iv: string): string {
		const cipher = forge.cipher.createCipher(AES_ALGORITHM, aesKey);
		cipher.start({ iv });
		cipher.update(forge.util.createBuffer(message, TEXT_ENCODING));
		if (!cipher.finish()) {
			throw new Error('AES encryption failed');
		}

		return cipher.output.getBytes();
	}

	private pack(iv: string, encryptedAesKey: string, encryptedMessage: string): string {
		const buffer: forge.util.ByteBuffer = forge.util.createBuffer();

		buffer.putBytes(iv);
		buffer.putBytes(encryptedAesKey);
		buffer.putBytes(encryptedMessage);

		return forge.util.encode64(buffer.getBytes());
	}
}
